// extracted by mini-css-extract-plugin
export default {"RegItemBuyingOptionsModalSkeleton":"RegItemBuyingOptionsModal-skeleton-styles__RegItemBuyingOptionsModalSkeleton__TCpSn"};